import { useNavigate } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import RobotMascot from "./RobotMascot";
import { IMAGES } from "../content";

const ApplyForm = () => {
  const navigate = useNavigate();
  return (
    <section id="apply" data-testid="apply" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2.5rem] bg-[#0B1B33] p-8 md:p-16 lg:p-20">
            <div className="absolute inset-0 bg-grid opacity-[0.07] invert" aria-hidden="true" />
            <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#007AFF]/30 blur-[110px]" aria-hidden="true" />
            <div className="absolute -bottom-32 -left-24 w-96 h-96 rounded-full bg-[#14D8A5]/25 blur-[110px]" aria-hidden="true" />

            <div className="relative grid lg:grid-cols-2 gap-14 items-center">
              <div>
                <p className="label-mono text-[#7FE9FF] mb-4">Apply · full application</p>
                <h2 className="font-display font-bold tracking-[-0.02em] leading-[1.02] text-white text-4xl md:text-6xl">
                  Ready when<br />you are.
                </h2>
                <p className="mt-6 max-w-md text-base leading-relaxed text-white/65">
                  The full application takes about ten minutes across eight quick steps — no tax
                  returns, and no impact on your personal credit at this stage.
                </p>
                <ul className="mt-9 space-y-4">
                  {["8 steps · about 10 minutes", "Last 4 months of bank statements", "Decision inside 24 hours"].map((t, i) => (
                    <li key={i} className="flex items-center gap-3 text-sm text-white/80">
                      <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#14D8A5]/20 text-[#14D8A5]">
                        <Check className="w-3.5 h-3.5" />
                      </span>
                      {t}
                    </li>
                  ))}
                </ul>
                <div className="mt-10 hidden lg:block">
                  <span className="lr-float-slow inline-block">
                    <RobotMascot className="w-24" dark />
                  </span>
                </div>
              </div>

              <div className="relative rounded-3xl bg-white p-10 text-center">
                <img src={IMAGES.card} alt="Robot presenting a card" className="w-44 mx-auto" draggable="false" />
                <p className="label-mono text-[#52525B]">Free · no impact to credit at this stage</p>
                <h3 className="font-display text-2xl font-bold text-[#0A1628] mt-3">Start the full application</h3>
                <p className="mt-3 text-sm text-[#52525B] leading-relaxed">
                  Save-as-you-go. Nothing is stored until you sign and submit at the final step.
                </p>
                <button
                  data-testid="apply-cta-go"
                  onClick={() => navigate("/apply")}
                  className="group mt-7 w-full inline-flex items-center justify-center gap-2.5 rounded-full bg-[#007AFF] px-7 py-4 text-base font-semibold text-white shadow-[0_12px_32px_rgba(0,122,255,0.35)] transition-all duration-300 hover:bg-[#0A1628] hover:-translate-y-0.5"
                >
                  Start now
                  <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
                </button>
                <p className="mono mt-4 text-[11px] text-[#52525B]">8 steps · ~10 min · statements required</p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ApplyForm;
